import { ApiService } from '../apiService';

class Branding extends ApiService {
  getBranding() {
    return this.get('branding/');
  }
}

export default new Branding();
